import React from "react";
import { Card, Col, Row } from "react-bootstrap";

import { TEAM_LOGO_URL } from "@lib/globals";

import { HeaderProps } from "@Leagues/types/leagues";

const Header = (props: HeaderProps): React.JSX.Element => {
    const { team, ageLevel, designation, direction, standingsData } = props;

    return (
        <div className="team-header">
            <Row className="row align-items-center">
                <Col
                    lg={3}
                    md={4}
                    className="text-center text-lg-start mb-3 mb-lg-0"
                >
                    <div className="mx-auto mx-lg-0">
                        {team?.logo && (
                            <img
                                src={`${TEAM_LOGO_URL}${team.logo}`}
                                alt={`${team.name} logo`}
                                className="teamLogo"
                            />
                        )}
                    </div>
                </Col>
                <Col lg={6} md={8} className="text-center text-lg-start">
                    <h1 className="team-name-header">
                        {team?.name || "Unknown Team"}
                    </h1>
                    <p className="team-league">
                        {ageLevel}
                        {designation ? ` ${designation}` : ""}
                        {direction ? ` ${direction}` : ""}
                    </p>
                </Col>
                <Col lg={3} className="text-center mt-3 mt-lg-0">
                    <Card className="record-card">
                        <div className="record-number">
                            {standingsData?.wins || 0}-
                            {standingsData?.losses || 0}-
                            {standingsData?.ties || 0}
                        </div>
                        <div className="record-label">W-L-T</div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Header;
